import isEmpty from "lodash/isEmpty";
import { stringify as qsStringify } from "qs";

import { leaflyShopStringify, leaflyStringifyLegacy } from "./qs";

export const buildLegacyQueryPath = (
  path: string,
  obj: Parameters<typeof qsStringify>[0],
) => {
  if (!isEmpty(obj)) {
    const query = leaflyStringifyLegacy(obj);

    return `${path}?${query}`;
  } else {
    return path;
  }
};

export const buildQueryPath = (
  path: string,
  obj: Parameters<typeof qsStringify>[0],
) => {
  if (!isEmpty(obj)) {
    const query = leaflyShopStringify(obj);

    return `${path}?${query}`;
  } else {
    return path;
  }
};
